<kendo-loader *ngIf="GetValue(); else fanOff"  type="infinite-spinner">
</kendo-loader>
<ng-template #fanOff>
  <span class="k-icon k-i-close k-icon-md"></span>
</ng-template>

